import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/post/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/post/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/post/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadPost(params) {
  let postId = '';
  postId = params.id.split('-')[0];
  if (isNaN(postId)) {
    postId = params.id;
  }
  return {
    [RSAA]: {
      ...api.getPost(postId),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  saving: false,
  error: '',
  data: {},
};

export default function singlePostReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
